"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
var axios_1 = __importDefault(require("axios"));
var query_string_1 = __importDefault(require("query-string"));
var Auth = /** @class */ (function () {
    function Auth(config, JWTMemory) {
        var base_url = config.base_url, use_cookies = config.use_cookies, refresh_interval_time = config.refresh_interval_time, client_storage = config.client_storage, client_storage_type = config.client_storage_type, ssr = config.ssr;
        this.use_cookies = use_cookies;
        this.refresh_interval_time = refresh_interval_time;
        this.client_storage = client_storage;
        this.client_storage_type = client_storage_type;
        this.login_state = null;
        this.token_changed_functions = [];
        this.auth_changed_functions = [];
        this.refresh_interval;
        this.refresh_sleep_check_interval;
        this.refresh_interval_sleep_check_last_sample;
        this.sample_rate = 2000; // check every 2 seconds
        this.JWTMemory = JWTMemory;
        this.ssr = ssr;
        this.http_client = axios_1.default.create({
            baseURL: base_url + "/auth",
            timeout: 10000,
            withCredentials: this.use_cookies,
        });
        // get refresh token from query param (from externa OAuth provider callback)
        var refresh_token = null;
        if (!ssr) {
            try {
                var parsed = query_string_1.default.parse(window.location.search);
                refresh_token =
                    "refresh_token" in parsed ? parsed.refresh_token : null;
                if (refresh_token) {
                    var new_url = this._removeParam("refresh_token", window.location.href);
                    try {
                        window.history.pushState({}, document.title, new_url);
                    }
                    catch (_a) {
                        // noop
                        // window object not available
                    }
                }
            }
            catch (e) {
                // noop. `window` not available probably.
            }
        }
        refresh_token = refresh_token !== "" ? refresh_token : null;
        this.autoLogin(refresh_token);
    }
    Auth.prototype._removeParam = function (key, sourceURL) {
        var rtn = sourceURL.split("?")[0], param, params_arr = [], queryString = sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
        if (queryString !== "") {
            params_arr = queryString.split("&");
            for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                param = params_arr[i].split("=")[0];
                if (param === key) {
                    params_arr.splice(i, 1);
                }
            }
            if (params_arr.length > 0) {
                rtn = rtn + "?" + params_arr.join("&");
            }
        }
        return rtn;
    };
    Auth.prototype.setItem = function (key, value) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (typeof value !== "string") {
                            return [2 /*return*/, console.error("value is not of type \"string\"")];
                        }
                        _a = this.client_storage_type;
                        switch (_a) {
                            case "web": return [3 /*break*/, 1];
                            case "react-native": return [3 /*break*/, 2];
                            case "capacitor": return [3 /*break*/, 4];
                            case "expo-secure-storage": return [3 /*break*/, 6];
                        }
                        return [3 /*break*/, 7];
                    case 1:
                        if (typeof this.client_storage.setItem !== "function") {
                            console.error("this.client_storage.setItem is not a function");
                            return [3 /*break*/, 8];
                        }
                        this.client_storage.setItem(key, value);
                        return [3 /*break*/, 8];
                    case 2:
                        if (typeof this.client_storage.setItem !== "function") {
                            console.error("this.client_storage.setItem is not a function");
                            return [3 /*break*/, 8];
                        }
                        return [4 /*yield*/, this.client_storage.setItem(key, value)];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 8];
                    case 4:
                        if (typeof this.client_storage.set !== "function") {
                            console.error("this.client_storage.set is not a function");
                            return [3 /*break*/, 8];
                        }
                        return [4 /*yield*/, this.client_storage.set({ key: key, value: value })];
                    case 5:
                        _b.sent();
                        return [3 /*break*/, 8];
                    case 6:
                        if (typeof this.client_storage.setItemAsync !== "function") {
                            console.error("this.client_storage.setItemAsync is not a function");
                            return [3 /*break*/, 8];
                        }
                        this.client_storage.setItemAsync(key, value);
                        return [3 /*break*/, 8];
                    case 7: return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    Auth.prototype.getItem = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, res;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.client_storage_type;
                        switch (_a) {
                            case "web": return [3 /*break*/, 1];
                            case "react-native": return [3 /*break*/, 2];
                            case "capacitor": return [3 /*break*/, 4];
                            case "expo-secure-storage": return [3 /*break*/, 6];
                        }
                        return [3 /*break*/, 7];
                    case 1:
                        if (typeof this.client_storage.getItem !== "function") {
                            console.error("this.client_storage.getItem is not a function");
                            return [3 /*break*/, 8];
                        }
                        return [2 /*return*/, this.client_storage.getItem(key)];
                    case 2:
                        if (typeof this.client_storage.getItem !== "function") {
                            console.error("this.client_storage.getItem is not a function");
                            return [3 /*break*/, 8];
                        }
                        return [4 /*yield*/, this.client_storage.getItem(key)];
                    case 3: return [2 /*return*/, _b.sent()];
                    case 4:
                        if (typeof this.client_storage.get !== "function") {
                            console.error("this.client_storage.get is not a function");
                            return [3 /*break*/, 8];
                        }
                        return [4 /*yield*/, this.client_storage.get({ key: key })];
                    case 5:
                        res = _b.sent();
                        return [2 /*return*/, res.value];
                    case 6:
                        if (typeof this.client_storage.getItemAsync !== "function") {
                            console.error("this.client_storage.getItemAsync is not a function");
                            return [3 /*break*/, 8];
                        }
                        return [2 /*return*/, this.client_storage.getItemAsync(key)];
                    case 7: return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    Auth.prototype.removeItem = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.client_storage_type;
                        switch (_a) {
                            case "web": return [3 /*break*/, 1];
                            case "react-native": return [3 /*break*/, 2];
                            case "capacitor": return [3 /*break*/, 4];
                            case "expo-secure-storage": return [3 /*break*/, 6];
                        }
                        return [3 /*break*/, 7];
                    case 1:
                        if (typeof this.client_storage.removeItem !== "function") {
                            console.error("this.client_storage.removeItem is not a function");
                            return [3 /*break*/, 8];
                        }
                        return [2 /*return*/, this.client_storage.removeItem(key)];
                    case 2:
                        if (typeof this.client_storage.removeItem !== "function") {
                            console.error("this.client_storage.removeItem is not a function");
                            return [3 /*break*/, 8];
                        }
                        return [4 /*yield*/, this.client_storage.removeItem(key)];
                    case 3: return [2 /*return*/, _b.sent()];
                    case 4:
                        if (typeof this.client_storage.remove !== "function") {
                            console.error("this.client_storage.remove is not a function");
                            return [3 /*break*/, 8];
                        }
                        return [4 /*yield*/, this.client_storage.remove({ key: key })];
                    case 5:
                        _b.sent();
                        return [3 /*break*/, 8];
                    case 6:
                        if (typeof this.client_storage.deleteItemAsync !== "function") {
                            console.error("this.client_storage.deleteItemAsync is not a function");
                            return [3 /*break*/, 8];
                        }
                        this.client_storage.deleteItemAsync(key);
                        return [3 /*break*/, 8];
                    case 7: return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    Auth.prototype.generateHeaders = function () {
        if (this.use_cookies)
            return null;
        var jwt_token = this.JWTMemory.getJWT();
        return {
            Authorization: "Bearer " + jwt_token,
        };
    };
    Auth.prototype.autoLogin = function (refresh_token) {
        if (this.ssr) {
            return this.setLoginState(null);
        }
        this.refreshToken(refresh_token);
    };
    Auth.prototype.setLoginState = function (state, jwt_token, jwt_expires_in) {
        var _this = this;
        if (jwt_token === void 0) { jwt_token = ""; }
        if (jwt_expires_in === void 0) { jwt_expires_in = 0; }
        // set new jwt_token
        if (jwt_token) {
            this.JWTMemory.setJWT(jwt_token);
        }
        // early exit
        if (this.login_state === state)
            return;
        // State has changed!
        // set new login_state
        this.login_state = state;
        if (this.login_state) {
            var refresh_interval_time = this.refresh_interval_time !== null ||
                typeof jwt_expires_in !== "number"
                ? this.refresh_interval_time
                : Math.max(30 * 1000, jwt_expires_in - 45000); //45 sec before expires
            // start refresh token interval after logging in
            this.refresh_interval = setInterval(this.refreshToken.bind(this), refresh_interval_time);
            // refresh token after computer has been sleeping
            // https://stackoverflow.com/questions/14112708/start-calling-js-function-when-pc-wakeup-from-sleep-mode
            this.refresh_interval_sleep_check_last_sample = Date.now();
            this.refresh_sleep_check_interval = setInterval(function () {
                if (Date.now() - _this.refresh_interval_sleep_check_last_sample >=
                    _this.sample_rate * 2) {
                    _this.refreshToken();
                }
                _this.refresh_interval_sleep_check_last_sample = Date.now();
            }, this.sample_rate);
        }
        else {
            // stop refresh interval
            clearInterval(this.refresh_interval);
            clearInterval(this.refresh_sleep_check_interval);
        }
        // call auth state change functions
        this.authStateChanged(this.login_state);
    };
    Auth.prototype.register = function (email, password, user_data) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.http_client.post("/register", {
                                email: email,
                                password: password,
                                user_data: user_data,
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Auth.prototype.login = function (email, password) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.http_client.post("/login", {
                                email: email,
                                password: password,
                                cookie: this.use_cookies,
                            })];
                    case 1:
                        res = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        this.removeItem("refresh_token");
                        throw error_2;
                    case 3:
                        if ("mfa" in res.data) {
                            return [2 /*return*/, res.data];
                        }
                        this.setLoginState(true, res.data.jwt_token, res.data.jwt_expires_in);
                        if (!!this.use_cookies) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.setItem("refresh_token", res.data.refresh_token)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/, {}];
                }
            });
        });
    };
    Auth.prototype.logout = function (all) {
        if (all === void 0) { all = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d, _e, error_3;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 3, , 4]);
                        _b = (_a = this.http_client).post;
                        _c = ["/logout", {
                                all: all,
                            }];
                        _d = {};
                        _e = {};
                        return [4 /*yield*/, this.getItem("refresh_token")];
                    case 1: return [4 /*yield*/, _b.apply(_a, _c.concat([(_d.params = (_e.refresh_token = _f.sent(),
                                _e),
                                _d)]))];
                    case 2:
                        _f.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _f.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        this.JWTMemory.clearJWT();
                        this.removeItem("refresh_token");
                        this.setLoginState(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    Auth.prototype.onTokenChanged = function (fn) {
        this.token_changed_functions.push(fn);
    };
    Auth.prototype.onAuthStateChanged = function (fn) {
        var _this = this;
        this.auth_changed_functions.push(fn);
        // get index;
        var auth_changed_function_index = this.auth_changed_functions.length - 1;
        var unsubscribe = function () {
            try {
                // replace onAuthStateChanged with empty function
                _this.auth_changed_functions[auth_changed_function_index] = function () { };
            }
            catch (err) {
                console.warn("Unable to unsubscribe. Maybe you already did?");
            }
        };
        return unsubscribe;
    };
    Auth.prototype.isAuthenticated = function () {
        return this.login_state;
    };
    Auth.prototype.getJWTToken = function () {
        return this.JWTMemory.getJWT();
    };
    Auth.prototype.getClaim = function (claim) {
        return this.JWTMemory.getClaim(claim);
    };
    Auth.prototype.refreshToken = function (init_refresh_token) {
        return __awaiter(this, void 0, void 0, function () {
            var refresh_token, _a, res, error_4;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = init_refresh_token;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getItem("refresh_token")];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        refresh_token = _a;
                        if (!refresh_token) {
                            // palce at end of call-stack to let frontend get `null` first (to match SSR)
                            setTimeout(function () { return _this.setLoginState(false); }, 0);
                            return [2 /*return*/];
                        }
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this.http_client.get("/token/refresh", {
                                params: {
                                    refresh_token: refresh_token,
                                },
                            })];
                    case 4:
                        res = _b.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        error_4 = _b.sent();
                        // TODO: if error was 401 Unauthorized => clear refresh token locally.
                        return [2 /*return*/, this.setLoginState(false)];
                    case 6:
                        if (!!this.use_cookies) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.setItem("refresh_token", res.data.refresh_token)];
                    case 7:
                        _b.sent();
                        _b.label = 8;
                    case 8:
                        this.setLoginState(true, res.data.jwt_token, res.data.jwt_expires_in);
                        this.tokenChanged();
                        return [2 /*return*/];
                }
            });
        });
    };
    Auth.prototype.tokenChanged = function () {
        for (var _i = 0, _a = this.token_changed_functions; _i < _a.length; _i++) {
            var tokenChangedFunction = _a[_i];
            tokenChangedFunction();
        }
    };
    Auth.prototype.authStateChanged = function (state) {
        for (var _i = 0, _a = this.auth_changed_functions; _i < _a.length; _i++) {
            var authChangedFunction = _a[_i];
            authChangedFunction(state);
        }
    };
    Auth.prototype.activate = function (ticket) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http_client.get("/activate?ticket=" + ticket)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Auth.prototype.changeEmail = function (new_email) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http_client.post("/change-email", {
                            new_email: new_email,
                        }, {
                            headers: this.generateHeaders(),
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Auth.prototype.changeEmailRequest = function (new_email) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http_client.post("/change-email/request", {
                            new_email: new_email,
                        }, {
                            headers: this.generateHeaders(),
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Auth.prototype.changeEmailChange = function (ticket) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http_client.post("/change-email/change", {
                            ticket: ticket,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Auth.prototype.changePassword = function (old_password, new_password) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http_client.post("/change-password", {
                            old_password: old_password,
                            new_password: new_password,
                        }, {
                            headers: this.generateHeaders(),
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Auth.prototype.changePasswordRequest = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http_client.post("/change-password/request", {
                            email: email,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Auth.prototype.changePasswordChange = function (new_password, ticket) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http_client.post("/change-password/change", {
                            new_password: new_password,
                            ticket: ticket,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Auth.prototype.MFAGenerate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http_client.post("/mfa/generate", {}, {
                            headers: this.generateHeaders(),
                        })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    Auth.prototype.MFAEnable = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http_client.post("/mfa/enable", {
                            code: code,
                        }, {
                            headers: this.generateHeaders(),
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Auth.prototype.MFADisable = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http_client.post("/mfa/disable", {
                            code: code,
                        }, {
                            headers: this.generateHeaders(),
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Auth.prototype.MFATotp = function (code, ticket) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http_client.post("/mfa/totp", {
                            code: code,
                            ticket: ticket,
                            cookie: this.use_cookies,
                        })];
                    case 1:
                        res = _a.sent();
                        this.setLoginState(true, res.data.jwt_token, res.data.jwt_expires_in);
                        if (!!this.use_cookies) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.setItem("refresh_token", res.data.refresh_token)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return Auth;
}());
exports.default = Auth;
//# sourceMappingURL=Auth.js.map